import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useApp } from "../../contexts/AppContext";
import { useTheme } from "../../contexts/ThemeContext";

export const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { currentUser, isAdmin } = useApp();
  const { isDark, toggleTheme } = useTheme();
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="h-[60px] bg-light-bg-secondary dark:bg-slate-900 border-b border-light-border dark:border-slate-700 flex items-center px-6 justify-between shrink-0 gap-4">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="bg-transparent border-none text-light-text-secondary dark:text-slate-400 cursor-pointer p-1.5 rounded-lg text-lg leading-none hover:bg-light-bg-tertiary dark:hover:bg-slate-800 transition"
        >
          ☰
        </button>
        <div className="h-5 w-px bg-light-border dark:bg-slate-700" />
        <button
          onClick={() => navigate("/request")}
          className="flex items-center gap-1.5 px-3.5 py-1.5 bg-yellow-600 hover:bg-yellow-700 text-slate-900 rounded-lg cursor-pointer text-sm font-bold transition-colors"
        >
          + New Contract Request
        </button>
      </div>

      <div className="flex items-center gap-3 relative">
        <button
          onClick={toggleTheme}
          className="p-1.5 rounded-lg text-light-text-secondary dark:text-slate-400 hover:bg-light-bg-tertiary dark:hover:bg-slate-700 transition-colors"
          title={isDark ? "Switch to light mode" : "Switch to dark mode"}
        >
          {isDark ? "☀️" : "🌙"}
        </button>

        <div className="h-5 w-px bg-light-border dark:bg-slate-700" />

        <div className="text-sm text-light-text-secondary dark:text-slate-400 text-right mr-1">
          <div className="text-light-text dark:text-slate-100 font-medium">{currentUser?.displayName}</div>
          {isAdmin && <div className="text-yellow-600 text-sm font-medium">Administrator</div>}
        </div>

        <div
          onClick={() => setShowMenu(!showMenu)}
          className="w-9 h-9 rounded-full bg-gradient-to-br from-yellow-600 to-yellow-800 flex items-center justify-center text-slate-900 font-bold text-sm cursor-pointer hover:from-yellow-500 hover:to-yellow-700 transition"
        >
          {currentUser?.displayName?.[0] || "U"}
        </div>

        {showMenu && (
          <div className="absolute top-14 right-0 bg-light-bg-secondary dark:bg-slate-800 border border-light-border dark:border-slate-700 rounded-lg p-2 min-w-[180px] shadow-xl z-50">
            <div className="px-3 py-2 border-b border-light-border dark:border-slate-700 mb-1">
              <div className="text-sm text-light-text dark:text-slate-100 font-medium">{currentUser?.displayName}</div>
              <div className="text-sm text-light-text-secondary dark:text-slate-400">{currentUser?.mail}</div>
            </div>
            <button
              onClick={() => {
                setShowMenu(false);
                instance.logoutPopup();
              }}
              className="w-full px-3 py-2 bg-transparent border-none text-light-text-secondary dark:text-slate-400 cursor-pointer text-sm text-left rounded-lg hover:bg-light-bg-tertiary dark:hover:bg-slate-700 transition"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
